import {makeGetOpenObligationList} from 'main/factories/usecases';
import {GetOpenObligationListParams} from 'domain/usecases';
import {useSortBills} from 'presentation/pages/private/hooks/useSortBills';

export const getOpenObligationList = async (params?: GetOpenObligationListParams) => {
	try {
		const response = await makeGetOpenObligationList().get(params);
		const sortedData = useSortBills(response);
		return typeof response === 'string' ? [] : sortedData;
	} catch (error) {
		throw new Error();
	}
};
